import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import useP2PStore from '../stores/p2pStore';

const Main = () => {
  const navigate = useNavigate();
  const { disconnect } = useP2PStore();

  useEffect(() => {
    disconnect();
  }, [disconnect]);

  const handleCreateRoom = async (e) => {
    e.preventDefault();
    try {
      const roomId = Array.from({length: 16}, () => Math.floor(Math.random() * 10)).join('');
      navigate(`/room/created/${roomId}`);
    } catch (error) {
      // Show error message
      console.error('Failed to create room:', error);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-500 to-purple-600 px-4">
      <div className="bg-white/10 backdrop-blur-lg p-6 sm:p-8 rounded-2xl shadow-2xl w-full max-w-sm border border-white/20">
        <h1 className="text-3xl sm:text-4xl font-bold mb-6 sm:mb-8 text-center text-white">
          Rock Paper Scissors
        </h1>
        <button
          onClick={handleCreateRoom}
          className="w-full py-3 sm:py-4 bg-white/20 hover:bg-white/30 text-white text-base sm:text-lg font-semibold rounded-xl 
                   transition-all duration-300 ease-in-out transform hover:scale-105 
                   shadow-lg hover:shadow-xl border border-white/30"
        >
          Create New Game Room
        </button>
      </div>
    </div>
  );
};

export default Main;